export const reassignAndTerminateRequestTasks_actionType = {
    REASSIGN_AND_TERMINATE_REQUEST_TASKS: "REASSIGN_AND_TERMINATE_REQUEST_TASKS",
    REASSIGN_AND_TERMINATE_REQUEST_TASKS_SUCCESS: "REASSIGN_AND_TERMINATE_REQUEST_TASKS_SUCCESS",
    REASSIGN_AND_TERMINATE_REQUEST_TASKS_ERROR: "REASSIGN_AND_TERMINATE_REQUEST_TASKS_ERROR"
};